// Components
import { BoxLoader } from "../../../../components";

// Styled
import { LargeBlockStyled } from "../ViewStats.styled";
import { Typography } from "../../../../components/Typography";

const LargeBlock = ({ count, title, subtitle, isLoading }) => {
  return (
    <LargeBlockStyled>
      <Typography tag="p" nomargin fontSize="15" bold mb="20">
        {title}
      </Typography>
      {isLoading ? (
        <div style={{ width: 35, height: 35 }}>
          <BoxLoader tiny />
        </div>
      ) : (
        <Typography tag="p" nomargin fontSize="40" bold mb="15">
          {count}
        </Typography>
      )}
      <Typography tag="p" nomargin fontSize="12">
        {subtitle}
      </Typography>
    </LargeBlockStyled>
  );
};

export default LargeBlock;
